import { Magazine } from "../Datatypes";
import { usePersistBoundStore } from "../zustand/Store";

export const usePrepareStoredMagazine = () => {
    const getStoredMagazineByMagazine = usePersistBoundStore.getState().getStoredMagazineByMagazine;
    const updateStoredMagazine = usePersistBoundStore.getState().updateStoredMagazine;

    return async (magazine: Magazine) => {
        const stored = getStoredMagazineByMagazine(magazine);        
        if (!stored) {
            //console.log("prepareStoredMagazine - no stored Magazine exists");
            //console.log("prepareStoredMagazine - number of pages is: ", magazine.numberOfPages);
            if (magazine.pageFiles?.length != 0) {
                // generate the pageFiles data for the new stored magazine     
                //console.log("prepareStoredMagazine - storing magazine", JSON.stringify(magazine, null, 2));           
                updateStoredMagazine(magazine);
            } else {
                //console.error("prepareStoredMagazine - Error - numberOfPages missing in magazine");
            }    
        } else {
        //console.log("prepareStoredMagazine - stored Magazine exists", JSON.stringify(stored, null, 2));
        }
    }
}